module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "container",
    staticClass: "custom-chart-container p-compare-reserves__d3 u-position-relative"
  }, [_c('div', {
    ref: "tooltip",
    staticClass: "chart-tooltip"
  }, [_c('strong', [_vm._v("TITLE")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("COUNT")]), _vm._v(" claims\n    ")]), _vm._v(" "), _c('svg', {
    ref: "svg",
    staticClass: "custom-chart",
    attrs: {
      "height": _vm.height,
      "width": _vm.width
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3b87b024!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/compare/components/RangeChart.vue
// module id = 1648
// module chunks = 0